import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import mergeRefs from 'react-merge-refs';
/**
 * Safely merge a set of props which contains functions and
 * refs, ensuring that each function and ref are correctly
 * called. This is distinct from Object.assign which destructively
 * merges values with conflicting keys.
 */

export var mergePropsAndRefs = function mergePropsAndRefs() {
  var groupedFns = {};
  var fns = {};
  var refs = [];

  function propFnFactory(name) {
    return function (e) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var callbacks = groupedFns[name];

      if (e && e.defaultPrevented) {
        return;
      }

      callbacks.forEach(function (cb) {
        return cb.apply(void 0, [e].concat(args));
      });
    };
  }

  for (var _len = arguments.length, bindGroups = new Array(_len), _key = 0; _key < _len; _key++) {
    bindGroups[_key] = arguments[_key];
  }

  bindGroups.forEach(function (bind) {
    Object.entries(bind).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      if (key === 'ref') {
        refs.push(value);
        return;
      }

      if (typeof value !== 'function') {
        fns[key] = value;
        return;
      }

      if (!groupedFns[key]) {
        groupedFns[key] = [];
      }

      groupedFns[key].push(value);
      fns[key] = propFnFactory(key);
    });
  });

  if (refs.length > 0) {
    fns.ref = mergeRefs(refs);
  }

  return fns;
};